import { Editor } from '@tiptap/react';
import {
  BoldIcon,
  Box,
  BulletsIcon,
  Button,
  ItalicIcon,
  LockIcon,
} from '../../ui';
import { LinkIcon } from 'v1/ui/icons';

export default function MenuBar({ editor }: { editor: Editor }) {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        width: '100%',
        display: 'flex',
        pb: 2,
        pl: '12px',
      }}
    >
      <Control
        editor={editor}
        name="bulletList"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
      />
      <Control
        editor={editor}
        name="bold"
        onClick={() => editor.chain().focus().toggleBold().run()}
      />
      <Control
        editor={editor}
        name="italic"
        onClick={() => editor.chain().focus().toggleItalic().run()}
      />
      <Control
        editor={editor}
        name="link"
        onClick={() => {
          // Handle case where no text is selected to link
          const currentSelectionIsEmpty = editor.view.state.selection.empty;
          if (currentSelectionIsEmpty) {
            alert('Please select the text you want to link.');
            return;
          }
          // Remove the link if the selection is already a link
          const isAlreadyLink = editor.isActive('link');
          if (isAlreadyLink) {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            return;
          }
          // Add the link if the user entered a URL
          const url = prompt('Enter a URL');
          if (url) {
            editor
              .chain()
              .focus()
              .extendMarkRange('link')
              .setLink({ href: url })
              .run();
          }
        }}
      />
    </Box>
  );
}

function Control({
  name,
  onClick,
  editor,
}: {
  name: string;
  onClick: () => void;
  editor: Editor;
}) {
  const isActive = editor.isActive(name);
  const iconColor = isActive ? 'white' : 'black';
  return (
    <Button
      onClick={onClick}
      tabIndex={-1}
      sx={{
        borderRadius: 4,
        bg: isActive ? 'black70' : 'transparent',
        outline: 'none !important',
        width: 'auto',
        mr: 4,
        p: 0,
        transition: 'background 150ms linear',
        ':hover': {
          bg: isActive ? 'black70' : 'buttonGray',
        },
      }}
      variant="secondary"
    >
      {name === 'bulletList' ? (
        <BulletsIcon size={24} color={iconColor} />
      ) : name === 'bold' ? (
        <BoldIcon size={24} color={iconColor} />
      ) : name === 'italic' ? (
        <ItalicIcon size={24} color={iconColor} />
      ) : (
        <LinkIcon size={24} color={iconColor} />
      )}
    </Button>
  );
}
